<div class="info">
    <div class="name">
        {{incidentComment?.user?.name}}
    </div>
    <div class="date">
        @if (incidentComment.created_at) {
            {{incidentComment.created_at | date  : 'd MMM yyyy, H:mm'}}
        }
        @if (!incidentComment.created_at) {
            Nieuwe reactie
        }
    </div>
    <div>
        @if (!editing() && mayEdit()) {
            <button (click)="edit()" color="primary" mat-icon-button>
                <mat-icon class="fas fa-pencil-alt"></mat-icon>
            </button>
        }
        @if (mayEdit() && incidentComment.id) {
            <button (click)="deleteComment()" color="warn" mat-icon-button>
                <mat-icon class="fas fa-trash"></mat-icon>
            </button>
        }
    </div>
</div>
@if (editing()) {
    <mat-form-field appearance="fill" class="w-100">
        <mat-label>Uw reactie</mat-label>
        <textarea
            [(ngModel)]="incidentComment.comment"
            cdkTextareaAutosize
            matInput
            placeholder="Typ hier uw reactie...">
        </textarea>
    </mat-form-field>
}
@if (!editing()) {
    <div [innerHTML]="incidentComment.comment | nl2br" class="comment">
    </div>
}
<div class="files">
    @for (file of incidentComment.files; track file) {
        <div class="file">
            <div (click)="openFile.emit(file)" [class.is-img]="['jpg', 'jpeg', 'png'].indexOf(file.ext) !== -1">
                <div [style.background-image]="url + file.file+'?access_token='+token|safeBgUrl"
                     class="icon">
                    <i class="fas fa-file"></i>
                </div>
                <div class="filename">
                    {{file.name}}
                </div>
            </div>
        </div>
    }
</div>
@if (editing()) {
    <div class="actions">
        <button class="curpoint" mat-stroked-button style="padding: 0">
            <label style="margin: 0; padding: 0 16px; cursor: pointer">
                Bijlage toevoegen <input (change)="uploadFile($event)" hidden multiple type="file">
            </label>
        </button>

        <button (click)="placeOrEditComment()" [disabled]="!incidentComment.comment || saving()" color="primary" mat-flat-button>
            {{incidentComment.id ? 'Update reactie' : 'Plaats reactie'}}
            @if (saving()) {
                <i class="fas fa-circle-notch fa-spin"></i>
            }
        </button>
    </div>
}
